import dark from "./dark";
import light from "./light";


/** @description import vuetify-options to vuetify instance */
const defaultTheme = 'light'
export default {
    defaultTheme: defaultTheme,
    /** @see how to configure variation
        @tutorial https://vuetifyjs.com/en/features/theme/#color-variations */
    variations: {
        // colors: ['primary', 'secondary'],
        // lighten: 1,
        // darken: 2,
    },
    themes: {
        dark: dark,
        light: light,
    },
};
